import React, { Component } from "react";
import Page from "../../components/Page";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import { Breadcrumb, Button, Icon, Dropdown } from "semantic-ui-react";
import _ from "lodash";
import { post } from "../../util/api";
import moment from "moment";
import * as XLSX from "xlsx";

// state -> rozet metni + css sınıfı
const STATE_META = {
  pending: { key: "rvStatusPending", cls: "pending" },
  approved: { key: "rvStatusApproved", cls: "approved" },
  rejected: { key: "rvStatusRejected", cls: "rejected" },
};

class reviewHelper extends Component {
  state = {
    loading: true,
    data: [],
    saving: false,
    // filtreler
    statusFilter: "all", // all | pending | approved | rejected
    star: 0, // 0 = tümü
    sort: "date_desc", // date_desc | date_asc | star_desc | star_asc
    search: "",
    dateRange: { start: "", end: "" },
    // galeri lightbox
    gallery: null, // { item, index }
  };

  componentDidMount() {
    const { id } = this.props.product.personalize;
    post("/personalize/getCommentWithAdmin/list", { pid: id }).then((res) => {
      const sorted = _.sortBy(res.data.result, (it) => it.created_at).reverse();
      this.setState({ loading: false, data: sorted });
    });
    document.addEventListener("keydown", this.handleKeyDown);
  }

  componentWillUnmount() {
    document.removeEventListener("keydown", this.handleKeyDown);
  }

  /* ----- veriden türetilen yardımcılar ----- */
  getStatus = (it) => {
    if (it.extra && it.extra.hidden) return "rejected";
    return it.verify ? "approved" : "pending";
  };

  getRate = (it) => {
    const n = parseInt(it && it.extra && it.extra.rate, 10);
    if (isNaN(n)) return 0;
    return Math.max(0, Math.min(5, n));
  };

  getMedia = (it) => (it && it.extra && it.extra.mediaFiles) || [];

  counts = () => {
    const c = { all: this.state.data.length, pending: 0, approved: 0, rejected: 0 };
    this.state.data.forEach((it) => {
      c[this.getStatus(it)]++;
    });
    return c;
  };

  getFilteredData = () => {
    const { data, statusFilter, star, sort, search, dateRange } = this.state;
    const q = search.trim().toLowerCase();
    const start = dateRange.start ? new Date(dateRange.start) : null;
    const end = dateRange.end ? new Date(dateRange.end + "T23:59:59") : null;

    const filtered = data.filter((it) => {
      if (statusFilter !== "all" && this.getStatus(it) !== statusFilter) return false;
      if (star && this.getRate(it) !== star) return false;
      const d = new Date(it.created_at);
      if (start && d < start) return false;
      if (end && d > end) return false;
      if (q) {
        const hay = `${it.product_id || ""} ${(it.extra && it.extra.orderNumber) || ""} ${
          (it.extra && it.extra.comment) || ""
        }`.toLowerCase();
        if (!hay.includes(q)) return false;
      }
      return true;
    });

    const time = (it) => new Date(it.created_at).getTime() || 0;
    return filtered.sort((a, b) => {
      switch (sort) {
        case "date_asc":
          return time(a) - time(b);
        case "star_desc":
          return this.getRate(b) - this.getRate(a);
        case "star_asc":
          return this.getRate(a) - this.getRate(b);
        default:
          return time(b) - time(a);
      }
    });
  };

  /* ----- mutasyonlar (her aksiyon anında backend'e yazılır) ----- */
  // İyimser güncelleme: önce UI değişir, ardından kaydedilir; hata olursa geri alınır.
  applyAndPersist = (updatedData, changedItems) => {
    if (!changedItems.length) return;
    const prevData = this.state.data;
    this.setState({ data: updatedData, saving: true });
    post("/personalize/getCommentWithAdmin/change", { changedData: changedItems })
      .then(() => this.setState({ saving: false }))
      .catch(() => this.setState({ data: prevData, saving: false }));
  };

  setItemStatus = (item, status) => {
    const verify = status === "approved";
    const hidden = status === "rejected";
    const key = `${item.sid}-${item.id}`;
    let changed = null;
    const data = this.state.data.map((it) => {
      if (`${it.sid}-${it.id}` === key) {
        changed = { ...it, verify, extra: { ...it.extra, hidden } };
        return changed;
      }
      return it;
    });
    this.applyAndPersist(data, changed ? [changed] : []);
  };

  bulkApprove = () => {
    const keys = this.getFilteredData()
      .filter((it) => this.getStatus(it) === "pending")
      .map((it) => `${it.sid}-${it.id}`);
    if (!keys.length) return;
    const changed = [];
    const data = this.state.data.map((it) => {
      if (keys.indexOf(`${it.sid}-${it.id}`) !== -1) {
        const updated = { ...it, verify: true, extra: { ...it.extra, hidden: false } };
        changed.push(updated);
        return updated;
      }
      return it;
    });
    this.applyAndPersist(data, changed);
  };

  /* ----- filtre handler'ları ----- */
  setFilter = (patch) => this.setState(patch);

  resetFilters = () =>
    this.setState({
      statusFilter: "all",
      star: 0,
      sort: "date_desc",
      search: "",
      dateRange: { start: "", end: "" },
    });

  /* ----- dışa aktarma (ekrandaki filtrelenmiş/sıralı veriyi aktarır) ----- */
  buildExportRows = () => {
    const { t } = this.props;
    const statusLabel = {
      pending: t("rvStatusPending"),
      approved: t("rvStatusApproved"),
      rejected: t("rvStatusRejected"),
    };
    const fmt = (d) => (d ? moment(d).locale(t("lang")).format("YYYY-MM-DD HH:mm") : "");
    return this.getFilteredData().map((it) => {
      const e = it.extra || {};
      const media = this.getMedia(it);
      return {
        [t("productId")]: it.product_id || "",
        [t("orderNumber")]: e.orderNumber || "",
        [t("productLink")]: e.absolute_url ? `https://${e.absolute_url}` : "",
        [t("userName")]: e.userFullName || "",
        [t("customerMail")]: e.email || "",
        [t("rvRating")]: this.getRate(it),
        [t("rvStatus")]: statusLabel[this.getStatus(it)],
        [t("commentContent")]: e.comment || "",
        [t("imageComment")]: media.length,
        [t("rvImageUrls")]: media.map((m) => m.url).filter(Boolean).join(" | "),
        [t("createdDate")]: fmt(it.created_at),
        [t("updated_at")]: fmt(it.updated_at),
      };
    });
  };

  buildSheet = (rows) => {
    const ws = XLSX.utils.json_to_sheet(rows);
    ws["!cols"] = [
      { wch: 12 }, // ürün id
      { wch: 16 }, // sipariş
      { wch: 40 }, // link
      { wch: 20 }, // kullanıcı
      { wch: 26 }, // email
      { wch: 8 }, // puan
      { wch: 14 }, // durum
      { wch: 60 }, // yorum
      { wch: 10 }, // görsel sayısı
      { wch: 50 }, // görsel url'leri
      { wch: 18 }, // oluşturma
      { wch: 18 }, // güncelleme
    ];
    return ws;
  };

  buildMarkdown = (rows) => {
    const headers = Object.keys(rows[0]);
    const esc = (v) =>
      String(v == null ? "" : v)
        .replace(/\|/g, "\\|")
        .replace(/\r?\n/g, " ");
    const line = (cells) => `| ${cells.join(" | ")} |`;
    return [
      line(headers),
      line(headers.map(() => "---")),
      ...rows.map((r) => line(headers.map((h) => esc(r[h])))),
    ].join("\n");
  };

  exportName = (ext) =>
    `CollectAction Yorumlar ${new Date().toLocaleDateString("tr-TR")}.${ext}`;

  download = (blob, filename) => {
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  };

  exportData = (type) => {
    const rows = this.buildExportRows();
    if (!rows.length) return;
    const name = this.exportName(type);

    if (type === "xlsx") {
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, this.buildSheet(rows), "Yorumlar");
      XLSX.writeFile(wb, name);
    } else if (type === "csv") {
      const csv = XLSX.utils.sheet_to_csv(this.buildSheet(rows));
      // UTF-8 BOM -> Excel'de Türkçe karakterler doğru görünsün
      this.download(new Blob(["﻿" + csv], { type: "text/csv;charset=utf-8" }), name);
    } else if (type === "md") {
      this.download(
        new Blob([this.buildMarkdown(rows)], { type: "text/markdown;charset=utf-8" }),
        name
      );
    }
  };

  /* ----- galeri lightbox ----- */
  openGallery = (item, index) => {
    if (!this.getMedia(item).length) return;
    this.setState({ gallery: { item, index } });
  };

  stepGallery = (dir) => {
    const { gallery } = this.state;
    if (!gallery) return;
    const total = this.getMedia(gallery.item).length;
    if (!total) return;
    this.setState({ gallery: { ...gallery, index: (gallery.index + dir + total) % total } });
  };

  closeGallery = () => this.setState({ gallery: null });

  handleKeyDown = (e) => {
    if (!this.state.gallery) return;
    if (e.key === "ArrowRight") this.stepGallery(1);
    else if (e.key === "ArrowLeft") this.stepGallery(-1);
    else if (e.key === "Escape") this.closeGallery();
  };

  /* ----- küçük render yardımcıları ----- */
  initials = (name) =>
    (name || "?")
      .trim()
      .split(/\s+/)
      .map((w) => w[0])
      .slice(0, 2)
      .join("")
      .toUpperCase();

  stars = (n) => "★★★★★☆☆☆☆☆".slice(5 - n, 10 - n);

  renderActions = (it, status) => {
    const { t } = this.props;
    if (status === "pending") {
      return (
        <>
          <button
            className="ca-act ca-act--approve"
            onClick={() => this.setItemStatus(it, "approved")}
          >
            ✓ {t("rvApprove")}
          </button>
          <button
            className="ca-act ca-act--reject-ghost"
            onClick={() => this.setItemStatus(it, "rejected")}
          >
            ✕ {t("rvReject")}
          </button>
        </>
      );
    }
    if (status === "approved") {
      return (
        <button
          className="ca-act ca-act--reject-ghost"
          onClick={() => this.setItemStatus(it, "rejected")}
        >
          ✕ {t("rvReject")}
        </button>
      );
    }
    return (
      <button
        className="ca-act ca-act--approve-ghost"
        onClick={() => this.setItemStatus(it, "approved")}
      >
        ✓ {t("rvApprove")}
      </button>
    );
  };

  renderImages = (it, media) => {
    const { t } = this.props;
    return (
      <div className="ca-imgs">
        <div className="ca-imgs__title">{t("rvImagesAdded", { n: media.length })}</div>
        <div className="ca-imgs__grid">
          {media.map((m, i) => (
            <div
              key={i}
              className="ca-thumb"
              style={m.url ? { backgroundImage: `url('${m.url}')` } : undefined}
              onClick={() => this.openGallery(it, i)}
            >
              {m.url ? null : (
                <>
                  <span className="ca-thumb__icon">🖼️</span>
                  <span className="ca-thumb__lbl">
                    {t("imageComment")} {i + 1}
                  </span>
                </>
              )}
            </div>
          ))}
        </div>
      </div>
    );
  };

  renderCard = (it) => {
    const { t } = this.props;
    const status = this.getStatus(it);
    const meta = STATE_META[status];
    const rate = this.getRate(it);
    const media = this.getMedia(it);
    const name = it.extra && it.extra.userFullName;
    const email = it.extra && it.extra.email;
    const comment = it.extra && it.extra.comment;
    const orderNumber = it.extra && it.extra.orderNumber;
    const link = it.extra && it.extra.absolute_url;
    const dateText = moment(it.created_at).locale(t("lang")).format("LL - HH:mm");

    return (
      <div className="ca-card" key={`${it.sid}-${it.id}`}>
        <div className="ca-card__head">
          <div className="ca-card__user">
            <div className="ca-avatar">{this.initials(name)}</div>
            <div style={{ minWidth: 0 }}>
              <div className="ca-card__name">{name || t("rvAnonymous")}</div>
              <div className="ca-card__meta">
                {email ? `${email} • ` : ""}
                {dateText}
              </div>
            </div>
          </div>
          <span className={`ca-badge ca-badge--${meta.cls}`}>
            <span className="ca-badge__dot" />
            {t(meta.key)}
          </span>
        </div>

        <div className="ca-card__rating">
          <span className="ca-stars">{this.stars(rate)}</span>
          <span className="ca-score">{rate}/5</span>
        </div>

        <div className={`ca-card__text${comment ? "" : " ca-card__text--empty"}`}>
          {comment || t("rvNoComment")}
        </div>

        {media.length > 0 && this.renderImages(it, media)}

        <div className="ca-card__foot">
          <div className="ca-card__info">
            <span>
              {t("productId")}: <b>{it.product_id || "-"}</b>
            </span>
            {orderNumber ? (
              <span>
                {t("orderNumber")}: <b>{orderNumber}</b>
              </span>
            ) : null}
            {link ? (
              <a
                className="ca-link"
                href={`https://${link}`}
                target="_blank"
                rel="noopener noreferrer"
              >
                {t("rvViewProduct")}
              </a>
            ) : null}
          </div>
          <div className="ca-actions">{this.renderActions(it, status)}</div>
        </div>
      </div>
    );
  };

  renderLightbox = () => {
    const { t } = this.props;
    const { gallery } = this.state;
    const media = this.getMedia(gallery.item);
    const total = media.length;
    const idx = gallery.index;
    const src = media[idx] && media[idx].url;
    const multi = total > 1;

    return (
      <div
        className="ca-lightbox"
        onClick={(e) => {
          if (e.target === e.currentTarget) this.closeGallery();
        }}
      >
        <button className="ca-lb__close" onClick={this.closeGallery}>
          ✕
        </button>
        {multi && (
          <div className="ca-lb__counter">
            {idx + 1} / {total}
          </div>
        )}
        {multi && (
          <button className="ca-lb__nav ca-lb__nav--prev" onClick={() => this.stepGallery(-1)}>
            ‹
          </button>
        )}
        {multi && (
          <button className="ca-lb__nav ca-lb__nav--next" onClick={() => this.stepGallery(1)}>
            ›
          </button>
        )}
        <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
          <div className="ca-lb__ctx">
            {(gallery.item.extra && gallery.item.extra.userFullName) || t("rvAnonymous")} •{" "}
            {gallery.item.product_id}
          </div>
          {src ? (
            <img className="ca-lb__img" src={src} alt="" />
          ) : (
            <div className="ca-lb__placeholder">
              <div style={{ fontSize: 58 }}>🖼️</div>
              <div
                style={{ fontWeight: 700, color: "#101828", fontSize: 17, marginTop: 14 }}
              >
                {t("imageComment")} {idx + 1}
                {multi ? ` / ${total}` : ""}
              </div>
              <div style={{ color: "#667085", fontSize: 13.5, marginTop: 8, lineHeight: 1.5 }}>
                {t("rvNoImageHint")}
              </div>
            </div>
          )}
          {multi && (
            <div className="ca-lb__strip">
              {media.map((m, i) => (
                <div
                  key={i}
                  className={`ca-gthumb${i === idx ? " is-active" : ""}`}
                  style={m.url ? { backgroundImage: `url('${m.url}')` } : undefined}
                  onClick={() => this.setState({ gallery: { ...gallery, index: i } })}
                >
                  {m.url ? null : <span style={{ fontSize: 20 }}>🖼️</span>}
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    );
  };

  render() {
    const { t } = this.props;
    const { loading, gallery, saving, statusFilter, star, sort, search, dateRange } = this.state;

    if (loading) {
      return (
        <Page icon="chart line" title={t("akinonCommentModule")}>
          <Page.Loader key="loader" />
        </Page>
      );
    }

    const c = this.counts();
    const filtered = this.getFilteredData();
    const pendingVisible = filtered.filter((it) => this.getStatus(it) === "pending").length;
    const tabs = [
      { key: "all", label: t("rvAll"), n: c.all },
      { key: "pending", label: t("rvPending"), n: c.pending },
      { key: "approved", label: t("rvApproved"), n: c.approved },
      { key: "rejected", label: t("rvRejected"), n: c.rejected },
    ];
    const stats = [
      { key: "all", color: "#101828", n: c.all, label: t("rvTotalComments") },
      { key: "pending", color: "#b9770e", n: c.pending, label: t("rvPending") },
      { key: "approved", color: "#1a7f43", n: c.approved, label: t("rvApproved") },
      { key: "rejected", color: "#c0392b", n: c.rejected, label: t("rvRejected") },
    ];

    return (
      <Page
        icon="chart line"
        title={t("akinonCommentModule")}
        header={
          <Breadcrumb size="big">
            <Breadcrumb.Section>{t("akinonCommentModule")}</Breadcrumb.Section>
          </Breadcrumb>
        }
        extra={
          <div style={{ marginLeft: "auto", display: "flex", gap: 12, alignItems: "center" }}>
            {saving && (
              <span
                style={{
                  color: "#667085",
                  fontSize: 13,
                  display: "inline-flex",
                  alignItems: "center",
                  gap: 6,
                }}
              >
                <Icon name="spinner" loading />
                {t("rvSaving")}
              </span>
            )}
            {pendingVisible > 0 && (
              <Button
                color="orange"
                content={t("BulkApproval")}
                icon="check"
                loading={saving}
                onClick={this.bulkApprove}
              />
            )}
            <Dropdown
              button
              labeled
              icon="download"
              text={t("rvExport")}
              className="icon"
              disabled={!filtered.length}
            >
              <Dropdown.Menu>
                <Dropdown.Item
                  icon="file excel"
                  text="Excel (.xlsx)"
                  onClick={() => this.exportData("xlsx")}
                />
                <Dropdown.Item
                  icon="file alternate"
                  text="CSV (.csv)"
                  onClick={() => this.exportData("csv")}
                />
                <Dropdown.Item
                  icon="markdown"
                  text="Markdown (.md)"
                  onClick={() => this.exportData("md")}
                />
              </Dropdown.Menu>
            </Dropdown>
          </div>
        }
      >
        <Page.Wrap>
          <div className="ca-wrap">
            {/* Filtre çubuğu */}
            <div className="ca-filterbar">
              <div className="ca-field">
                <label className="ca-label">📅 {t("qaStartDate")}</label>
                <input
                  className="ca-input"
                  type="date"
                  value={dateRange.start}
                  onChange={(e) =>
                    this.setFilter({ dateRange: { ...dateRange, start: e.target.value } })
                  }
                />
              </div>
              <div className="ca-field">
                <label className="ca-label">📅 {t("qaEndDate")}</label>
                <input
                  className="ca-input"
                  type="date"
                  value={dateRange.end}
                  onChange={(e) =>
                    this.setFilter({ dateRange: { ...dateRange, end: e.target.value } })
                  }
                />
              </div>
              <div className="ca-field">
                <label className="ca-label">🔖 {t("qaApprovalStatus")}</label>
                <select
                  className="ca-input"
                  value={statusFilter}
                  onChange={(e) => this.setFilter({ statusFilter: e.target.value })}
                >
                  <option value="all">{t("rvAll")}</option>
                  <option value="pending">{t("rvStatusPending")}</option>
                  <option value="approved">{t("rvStatusApproved")}</option>
                  <option value="rejected">{t("rvStatusRejected")}</option>
                </select>
              </div>
              <div className="ca-field">
                <label className="ca-label">⭐ {t("rvStarFilter")}</label>
                <select
                  className="ca-input"
                  value={star}
                  onChange={(e) => this.setFilter({ star: +e.target.value })}
                >
                  <option value="0">{t("rvAllStars")}</option>
                  {[5, 4, 3, 2, 1].map((s) => (
                    <option key={s} value={s}>
                      {t("rvStarsN", { n: s })}
                    </option>
                  ))}
                </select>
              </div>
              <div className="ca-field">
                <label className="ca-label">↕️ {t("rvSort")}</label>
                <select
                  className="ca-input"
                  value={sort}
                  onChange={(e) => this.setFilter({ sort: e.target.value })}
                >
                  <option value="date_desc">{t("rvSortDateDesc")}</option>
                  <option value="date_asc">{t("rvSortDateAsc")}</option>
                  <option value="star_desc">{t("rvSortStarDesc")}</option>
                  <option value="star_asc">{t("rvSortStarAsc")}</option>
                </select>
              </div>
              <div className="ca-field ca-field--grow">
                <label className="ca-label">🔍 {t("rvSearch")}</label>
                <input
                  className="ca-input"
                  type="text"
                  value={search}
                  placeholder={t("rvSearchPlaceholder")}
                  onChange={(e) => this.setFilter({ search: e.target.value })}
                />
              </div>
              <button className="ca-btn-reset" onClick={this.resetFilters}>
                ↺ {t("rvReset")}
              </button>
            </div>

            {/* Özet istatistikler (tıklayınca filtreler) */}
            <div className="ca-stats">
              {stats.map((s) => (
                <div
                  key={s.key}
                  className={`ca-stat ca-stat--btn${statusFilter === s.key ? " is-active" : ""}`}
                  onClick={() => this.setFilter({ statusFilter: s.key })}
                >
                  <div className="ca-stat__val" style={{ color: s.color }}>
                    {s.n}
                  </div>
                  <div className="ca-stat__lbl">{s.label}</div>
                </div>
              ))}
            </div>

            {/* Durum sekmeleri */}
            <div className="ca-tabs">
              {tabs.map((tb) => (
                <button
                  key={tb.key}
                  className={`ca-tab${statusFilter === tb.key ? " is-active" : ""}`}
                  onClick={() => this.setFilter({ statusFilter: tb.key })}
                >
                  {tb.label} <span className="ca-tab__count">{tb.n}</span>
                </button>
              ))}
            </div>

            {/* Yorum kartları */}
            <div className="ca-cards">
              {filtered.length ? (
                filtered.map((it) => this.renderCard(it))
              ) : (
                <div style={{ textAlign: "center", padding: 50, color: "#98a2b3" }}>
                  {t("rvNoResults")}
                </div>
              )}
            </div>
          </div>
        </Page.Wrap>
        {gallery && this.renderLightbox()}
      </Page>
    );
  }
}

const stateToProps = (state) => ({
  access: state.access,
  product: state.product,
  location: state.router.location,
});

export default connect(stateToProps)(withTranslation()(reviewHelper));
